import { Song } from '@repo/types'

import { ISpotifyTrack } from '@/store/integrations/spotify/types'

import { convertSong } from './convertSong'

export function convertSongs(spotifyTracks: ISpotifyTrack[] = []): Song[] {
  return spotifyTracks.map(convertSong)
}
